<div class="flex items-center justify-between">
  <h1 class="pb-5 font-brand text-28px font-bold text-neutral-800">
    {{ titleKey() | translate }}
  </h1>
  <app-rounded-icon-button
    icon="icon-cross"
    (onClick)="onClose.emit($event)"
  ></app-rounded-icon-button>
</div>

<form (submit)="$event.preventDefault(); onSubmit()">
  <label
    for="pongoKioskPhone"
    class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600"
  >
    {{ labelKey() | translate }}
  </label>

  @if (helpKey()) {
    <p class="mb-2 font-base text-xs font-normal text-neutral-500">
      {{ helpKey() | translate }}
    </p>
  }

  <app-kiosk-input-country-phone-atom
    id="pongoKioskPhone"
    [phone]="phone()"
    [useLocalFormat]="false"
    [defaultRegionCode]="defaultRegionCode()"
    (updatePhone)="phone.set($event)"
  />

  <app-numeric-keypad-atom
    (numberClick)="onKeypadNumberClick($event)"
    (deleteClick)="onKeypadDeleteClick()"
  ></app-numeric-keypad-atom>

  @if (errorMessage(); as message) {
    <div
      class="mt-2 font-base text-xs font-normal text-error-700"
      [translate]="message"
    ></div>
  }

  <div class="mt-10 flex flex-col">
    <app-button-atom
      size="L"
      [label]="'pongo.validate' | translate"
      [iconUrl]="isValidating() ? 'assets/images/spinner.svg' : undefined"
      [disabled]="!canSubmit()"
      type="kiosk-primary"
      [overrideTextColor]="accentColor()?.font"
      [overrideBgColor]="accentColor()?.background"
      [full]="true"
      (click)="onSubmit()"
    ></app-button-atom>
  </div>
</form>
